import { runtimeEnv } from 'config/runtimeEnv';
import { setCurrentUser } from 'utils/utils';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';

let env = runtimeEnv('B2B_API_BASE_URL');

export const getRolesAndPermissionsService = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.rolesAndPermissions.rolesAndPermissionsApi + '?type=B2B'}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getSupplierRolesApi = async (data) => {
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.rolesAndPermissions.supplierRolesApi + '?roleType=' + data?.role + '&businessType=' + data?.businessType}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getParentRolesService = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.rolesAndPermissions.parentRolesApi}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getFullPermissionsTreeService = async () => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.rolesAndPermissions.permissionsTreeApi}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getParentAssignedPermissionsService = async (parentRoleId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.rolesAndPermissions.rolePermissionsApi}/${parentRoleId}/permissions`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateParentPermissionsService = async (parentRoleId, permissionIds) => {
  const res = await requestInstance
    .patch(
      `${env}${API_ENDPOINT.rolesAndPermissions.rolePermissionsApi}/${parentRoleId}/permissions`,
      { permissionIds },
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getSubRolesService = async (parentRoleId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.rolesAndPermissions.subRolesApi}/${parentRoleId}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getFilteredPermissionsTreeService = async (parentRoleId) => {
  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.rolesAndPermissions.rolePermissionsApi}/${parentRoleId}/permissions/tree`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getSubRoleAssignedPermissionsService = async (subRoleId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.rolesAndPermissions.subRolesApi}/${subRoleId}/permissions`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const createSubRoleService = async (payload) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.rolesAndPermissions.subRolesApi}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateSubRoleService = async (subRoleId, payload) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.rolesAndPermissions.subRolesApi}/${subRoleId}`, payload)
    .catch((err) => err.response);
  return setCurrentUser(res);
};
